export interface VoiceOption {
  label: string;
  value: string;
  useSeedTTS?: boolean;
}

export const VOICE_LIST: VoiceOption[] = [
  { label: '小何', value: 'zh_female_xiaohe_uranus_bigtts', useSeedTTS: true },
  { label: '甜美桃子', value: 'zh_female_tianmeitaozi_uranus_bigtts', useSeedTTS: true },
  { label: '柔美女友', value: 'zh_female_roumeinvyou_uranus_bigtts', useSeedTTS: true },
  { label: '知性女声', value: 'zh_female_zhixingnv_uranus_bigtts', useSeedTTS: true },
  { label: '亲切女声', value: 'zh_female_qinqienv_uranus_bigtts', useSeedTTS: true },
  { label: '魅力苏菲', value: 'zh_female_sophie_uranus_bigtts', useSeedTTS: true },
  { label: '撒娇学妹', value: 'zh_female_sajiaoxuemei_uranus_bigtts', useSeedTTS: true },
  { label: '玲玲姐姐 2.0', value: 'zh_female_lingling_uranus_bigtts', useSeedTTS: true },
  { label: '黑猫侦探社咪仔', value: 'zh_female_mizai_uranus_bigtts', useSeedTTS: true },
  { label: '小天', value: 'zh_male_taocheng_uranus_bigtts', useSeedTTS: true },
  { label: '温暖阿虎', value: 'zh_male_wennuanahu_uranus_bigtts', useSeedTTS: true },
  { label: '渊博小叔', value: 'zh_male_yuanboxiaoshu_uranus_bigtts', useSeedTTS: true },
  { label: '悠悠君子', value: 'zh_male_youyoujunzi_uranus_bigtts', useSeedTTS: true },
  { label: '傲娇霸总', value: 'zh_male_aojiaobazong_uranus_bigtts', useSeedTTS: true },
  { label: '磁性男嗓2.0', value: 'ICL_uranus_zh_male_cixingnansang_tob', useSeedTTS: true },
  { label: '唐僧', value: 'zh_male_tangseng_uranus_bigtts', useSeedTTS: true },
  { label: '猴哥', value: 'zh_male_sunwukong_uranus_bigtts', useSeedTTS: true },
  { label: '佩奇猪2.0', value: 'zh_female_peiqi_uranus_bigtts', useSeedTTS: true },
  { label: '懒音绵宝', value: 'zh_male_lanyinmianbao_uranus_bigtts', useSeedTTS: true },
  { label: '四郎', value: 'zh_male_silang_uranus_bigtts', useSeedTTS: true },
  { label: '刘飞', value: 'zh_male_liufei_uranus_bigtts', useSeedTTS: true },
  { label: '大壹', value: 'zh_male_dayi_uranus_bigtts', useSeedTTS: true },
  { label: '湾区大叔', value: 'zh_female_wanqudashu_moon_bigtts', useSeedTTS: false },
  { label: '广州德哥', value: 'zh_male_guozhoudege_moon_bigtts', useSeedTTS: false },
  { label: '京腔侃爷', value: 'zh_male_jingqiangkanye_moon_bigtts', useSeedTTS: false },
  { label: '沪普男', value: 'zh_male_hupunan_mars_bigtts', useSeedTTS: false },
];
